import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import {
  FormArray,
  FormGroup,
  FormControl,
  FormBuilder,
  Validators
} from "@angular/forms";
import { Observable, of } from "rxjs";
import { Subject } from "rxjs";

import { DataService } from "./../../data.service";
import { AppConfig } from "./../../config";

@Component({
  selector: "app-metafieldview",
  templateUrl: "./metafieldview.component.html",
  styleUrls: ["./metafieldview.component.scss"]
})
export class MetafieldViewComponent implements OnInit {
  profileDisplayedColumns = ["profilename", "visible", "readonly"];

  metafield: any;
  metaProfileFieldJSON: string | any[];
  fgsArray = new Array<FormGroup>();
  isLoading = false;
  isError = false;
  errorMessage = "";
  metafieldId = "";
  fieldName = "";
  metaobjectId = "";
  metaobjectName = "";
  parentobjectId = "";
  parentobjectName = "";
  embeddedObject = false;
  virtualObject = false;
  modifiedby = "";
  modifieddate = "";

  fieldAttributesDefnJson: any;
  fieldAttributeArray = [];

  detailForm = this.fb.group({
    metaobjectid: "",
    metaobjectname: "",
    id: "",
    labelname: "",
    fieldname: "",
    fieldtype: "",
    standard: new FormControl({ value: false, disabled: true }),
    primaryfield: new FormControl({ value: false, disabled: true }),
    required: new FormControl({ value: false, disabled: true }),
    tenantfield: new FormControl({ value: false, disabled: true }),
    defaultvalue: "",
    parentobjectid: "",
    parentobjectname: "",
    description: "",
    hinttext: "",
    helptext: "",
    embeddedobject: new FormControl({ value: false, disabled: true }),
    virtualobject: new FormControl({ value: false, disabled: true }),
    active: new FormControl({ value: true, disabled: true }),
    attributes: {},
    sinceversionseq: "",
    deprecatedversionseq: ""
  });

  profileForm = this.fb.group({
    metaprofilefields: this.fb.array([])
  });

  get metaprofilefields(): FormArray {
    return this.profileForm.get("metaprofilefields") as FormArray;
  }

  attributeForm: FormGroup;
  attributeitems: FormArray;

  createItem(a, t, v, p = ""): FormGroup {
    return this.fb.group({
      attr: a,
      type: t,
      value: v,
      placeholder: p
    });
  }

  addAttributeItem(a, t, v, p = ""): void {
    this.attributeitems = this.attributeForm.get("attributeitems") as FormArray;
    this.attributeitems.push(this.createItem(a, t, v, p));
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private appConfig: AppConfig,
    private dataService: DataService
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.metafieldId = this.route.snapshot.params.id;
      this.fieldName = this.route.snapshot.params.fieldname;
      this.metaobjectId = this.route.snapshot.params.metaobjectid;
      this.metaobjectName = this.route.snapshot.params.metaobjectname;
      this.parentobjectId = this.route.snapshot.params.parentobjectid;
      if (this.parentobjectId == "none") this.parentobjectId = "";
      this.parentobjectName = this.route.snapshot.params.parentobjectname;
      if (this.parentobjectName == "none") this.parentobjectName = "";

      //always convert string to boolean while assigning to formcontrol ****
      var boolValue = this.route.snapshot.params.embeddedobject == "true";
      this.embeddedObject = boolValue;
      boolValue = this.route.snapshot.params.virtualobject == "true";
      this.virtualObject = boolValue;
    });

    /*
    this.detailForm.controls['standard'].disable();
    this.detailForm.controls['primaryfield'].disable();
    this.detailForm.controls['required'].disable();
    this.detailForm.controls['embeddedobject'].disable();
    this.detailForm.controls['virtualobject'].disable();
    this.detailForm.controls['active'].disable();
    */

    this.attributeForm = this.fb.group({
      fieldid: "",
      fieldname: "",
      attributeitems: this.fb.array([])
    });

    this.getMetafieldById();

    this.getMetaProfileFields().subscribe((res) => {
      //console.log("response",res);
    });

    //this.fieldAttributesDefnJson = JSON.parse(JSON.stringify(this.appConfig.fieldAttributes));
    this.fieldAttributesDefnJson = this.appConfig.fieldAttributes;
  }

  metaobjectDetail() {
    this.router.navigateByUrl(
      "home/metaobjectdetail/" + this.metaobjectId + "/" + this.metaobjectName
    );
  }
  editMetaField() {
    this.router.navigateByUrl(
      "/home/metafield/edit/" +
        this.metafieldId +
        "/" +
        this.fieldName +
        "/" +
        this.metaobjectId +
        "/" +
        this.metaobjectName +
        "/" +
        (this.parentobjectId == "" ? "none" : this.parentobjectId) +
        "/" +
        (this.parentobjectName == "" ? "none" : this.parentobjectName) +
        "/" +
        this.embeddedObject +
        "/" +
        this.virtualObject
    );
  }

  createPlaceholderFromValue(pValue) {
    console.log("pValue", pValue);
    var placeholder = "";
    var jsonValue;
    if (pValue != "") {
      // jsonValue = JSON.parse(pValue);
      jsonValue = pValue;
    }

    if (jsonValue instanceof Array) {
      for (let i = 0; i < jsonValue.length; i++) {
        placeholder = placeholder + jsonValue[i].value + "\n";
      }
    }
    return placeholder;
  }

  getMetafieldById() {
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      // domain: localStorage.getItem("domain"),
      // subdomain: localStorage.getItem("subdomain"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      data: {
        metafield: {
          id: this.metafieldId
        }
      }
    };

    this.isLoading = true;
    this.dataService.getMetafieldById(postOption).subscribe(
      (res) => {
        //alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          this.metafield = res.data.metafield;
          if (this.metafield != null) {
            this.metaobjectId = this.metafield.metaobjectid;
            this.metaobjectName = this.metafield.metaobjectname;

            this.detailForm.controls["metaobjectid"].setValue(
              this.metafield.metaobjectid
            );
            this.detailForm.controls["metaobjectname"].setValue(
              this.metafield.metaobjectname
            );
            this.detailForm.controls["id"].setValue(this.metafield.id);
            this.detailForm.controls["labelname"].setValue(
              this.metafield.labelname
            );
            this.detailForm.controls["fieldname"].setValue(
              this.metafield.fieldname
            );
            this.detailForm.controls["fieldtype"].setValue(
              this.metafield.fieldtype
            );
            this.detailForm.controls["standard"].setValue(
              this.metafield.standard
            );
            this.detailForm.controls["primaryfield"].setValue(
              this.metafield.primaryfield
            );
            this.detailForm.controls["required"].setValue(
              this.metafield.required
            );
            this.detailForm.controls["tenantfield"].setValue(
              this.metafield.tenantfield
            );
            this.detailForm.controls["defaultvalue"].setValue(
              this.metafield.defaultvalue
            );
            this.detailForm.controls["parentobjectid"].setValue(
              this.metafield.parentobjectid
            );
            this.detailForm.controls["parentobjectname"].setValue(
              this.metafield.parentobjectname
            );
            this.detailForm.controls["description"].setValue(
              this.metafield.description
            );
            this.detailForm.controls["hinttext"].setValue(
              this.metafield.hinttext
            );
            this.detailForm.controls["helptext"].setValue(
              this.metafield.helptext
            );
            this.detailForm.controls["embeddedobject"].setValue(
              this.metafield.embeddedobject
            );
            this.detailForm.controls["virtualobject"].setValue(
              this.metafield.virtualobject
            );
            this.detailForm.controls["active"].setValue(this.metafield.active);
            this.detailForm.controls["attributes"].setValue(
              this.metafield.attributes
            );
            this.detailForm.controls["sinceversionseq"].setValue(
              this.metafield.sinceversionseq != null
                ? this.metafield.sinceversionseq
                : 0
            );
            this.detailForm.controls["deprecatedversionseq"].setValue(
              this.metafield.deprecatedversionseq != null
                ? this.metafield.deprecatedversionseq
                : 0
            );

            this.modifiedby = this.metafield.modifiedby;
            this.modifieddate = this.metafield.modifieddate;
            this.fieldAttributeArray =
              this.fieldAttributesDefnJson[this.metafield.fieldtype];

            var fgArray = new Array<FormGroup>();
            //transform json to attribute form controls
            for (let i = 0; i < this.fieldAttributeArray.length; i++) {
              var item = this.fieldAttributeArray[i];

              var placeholder = "";
              if (item.attr.toLowerCase() == "options") {
                placeholder = this.createPlaceholderFromValue(
                  this.metafield.attributes[item.attr]
                );
              }

              console.log("placeholder", placeholder);
              //get value from the attributes
              var value = this.metafield.attributes[item.attr];
              if (value instanceof Array) {
                value = JSON.stringify(value);
              }

              this.addAttributeItem(item.attr, item.type, value, placeholder);
            }
          }
          this.isLoading = false;
        } else {
          console.log("no data");
          this.isLoading = false;
          //this.resetDetailFormControls();
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.errorMessage = err.message;
        this.isError = true;
        this.isLoading = false;
        //this.resetDetailFormControls();
      }
    );
  }

  getMetaProfileFields(): Observable<boolean> {
    var subject = new Subject<boolean>();
    subject.next(true);

    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      // domain: localStorage.getItem("domain"),
      // subdomain: localStorage.getItem("subdomain"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      data: {
        metaprofilefield: {
          metafieldid: this.metafieldId
        }
      }
    };

    this.isLoading = true;
    this.dataService.getMetaProfileFields(postOption).subscribe(
      (res) => {
        console.log(res);
        if (res.success == 1) {
          this.metaProfileFieldJSON = res.data.metaprofilefields;
          if (this.metaProfileFieldJSON != null) {
            //transform json to form controls
            for (let i = 0; i < this.metaProfileFieldJSON.length; i++) {
              var item = this.metaProfileFieldJSON[i];

              var fg = new FormGroup({
                id: new FormControl(item.id),
                organizationid: new FormControl(item.organizationid),
                profileid: new FormControl(item.profileid),
                profilename: new FormControl(item.profilename),
                metafieldid: new FormControl(item.metafieldid),
                metafieldname: new FormControl(item.metafieldname),
                visible: new FormControl({
                  value: item.visible,
                  disabled: true
                }),
                readonly: new FormControl({
                  value: item.readonly,
                  disabled: true
                })
              });

              this.fgsArray.push(fg);
            }

            this.profileForm.setControl(
              "metaprofilefields",
              new FormArray(this.fgsArray)
            );
          }
          this.isLoading = false;
        } else {
          console.log("no data ");
          this.errorMessage = res.message;
          this.isError = true;
          this.isLoading = false;
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.errorMessage = err.message;
        this.isError = true;
        this.isLoading = false;
      }
    );

    return subject.asObservable();
  }
}
